import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { ApiUrlHelper } from 'src/app/common/apiUrlHelper';
import { CommonConstant } from 'src/app/constants/common-constant';
import { commonErrorMessage } from 'src/app/constants/error-message-constant';
import { CommonService } from 'src/app/services/common/common.service';
import { SharedService } from 'src/app/services/shared.service';
import { StorageService } from 'src/app/services/storage/storage.service';

@Component({
  selector: 'app-edit-profile',
  templateUrl: './edit-profile.component.html',
  styleUrls: ['./edit-profile.component.scss']
})
export class EditProfileComponent {
  profileForm: FormGroup = this.formBuilder.group({});
  ImageTypePhoto: any;
  PhotoFile: any;
  userId: number = 0;
  AdminRoleList: any = [];
  ProfilePhoto: any;
  PhotoPath: string = '';
  commonConstant: any = [];
  errorMessage: any = [];

  constructor(private formBuilder: FormBuilder,
    private CommonService: CommonService,
    private toastr: ToastrService,
    private router: Router,
    private route: ActivatedRoute,
    private apiUrl: ApiUrlHelper,
    private spinner: NgxSpinnerService,
    private storageService: StorageService,
    private sharedService: SharedService,
  ) { }

  ngOnInit() {
    this.userId = (this.storageService.getValue('userId'));
    this.sharedService.setData('Edit Profile');
    this.onInitProfileForm();
    this.getProfileDetail();
    this.commonConstant = CommonConstant;
    this.errorMessage = commonErrorMessage;
  }

  onInitProfileForm() {
    this.profileForm = this.formBuilder.group({
      FirstName: ['', [Validators.required, Validators.maxLength(20)]],
      LastName: ['', [Validators.required, Validators.maxLength(20)]],
      PhoneNo: ['', [Validators.required, Validators.pattern(/^[6-9][0-9]{9}$/)]],
      Photo: [''],
      EmailId: [{ value: '', disabled: true }],
      UserRole: [{ value: '', disabled: true }]
    });
  }

  get profileFormControl() {
    return this.profileForm.controls;
  }

  getProfileDetail() {
    this.spinner.show();
    const apiUrl = this.apiUrl.apiUrl.Profile.GetProfile.replace("{id}", this.userId.toString());
    this.CommonService.doGet(apiUrl).pipe().subscribe({
      next: (data) => {
        if (data.data.photo) {
          (<HTMLInputElement>document.getElementById('userProfilePreview')).setAttribute("src", data.data.photo);
        }
        else {
          (<HTMLInputElement>document.getElementById('userProfilePreview')).setAttribute("src", "assets/img/default_img.jpg");
        }
        this.spinner.hide();
        this.setProfileForm(data.data);
      },
      error: (err) => {
        this.spinner.hide();
        console.log('getProfileDetail-Error', err);
      }
    });
  }

  setProfileForm(data: any) {
    this.profileForm.setValue({
      FirstName: data.firstName,
      LastName: data.lastName,
      EmailId: data.emailId,
      UserRole: data.adminRoleName,
      PhoneNo: data.mobileNo,
      Photo: data.photo ? data.photo : ''
    });
    this.PhotoPath = data.photo;
  }

  saveProfile() {
    if (!this.profileForm.valid) {
      return;
    }
    this.spinner.show();
    const form = new FormData();
    form.append('userId', this.profileForm.value.userId ? this.profileForm.value.userId.toString() : '0');
    form.append('firstName', this.profileForm.value.FirstName.trim());
    form.append('LastName', this.profileForm.value.LastName.trim());
    form.append('mobileNo', this.profileForm.value.PhoneNo);
    form.append("ProfilePhoto", this.ProfilePhoto);
    form.append("photo", this.PhotoPath);
    const apiUrl = this.apiUrl.apiUrl.Profile.EditProfile;
    this.CommonService.doPost(apiUrl, form).pipe().subscribe({
      next: (data) => {
        if (data.success) {
          this.spinner.hide();
          this.toastr.success(data.message);
          if (localStorage.getItem("adminRoleId") == "2") {
            this.router.navigate(['/student']);
          }
          else {
            this.router.navigate(['/user']);
          }
        }
        else {
          this.spinner.hide();
          this.toastr.error(data.message);
          this.router.navigate(['/edit-profile']);
        }
      },
      error: (er) => {
        console.error(er)
      }
    });
  }

  onCancel() {
    this.router.navigate(['/profile']);
  }

  onFileChanged(event: any) {
    if (event.target.files && event.target.files[0]) {
      const reader = new FileReader();
      let file: any;
      var ext = event.target.files[0].name.match(/\.([^\.]+)$/)[1];
      var size = event.target.files[0].size;
      switch (ext.toLowerCase()) {
        case 'jpg':
        case 'jpeg':
        case 'png':
          break;
        default:
          this.toastr.error("Please select only JPG, JPEG or PNG image");
          (<HTMLInputElement>document.getElementById('uploadUserImage')).value = "";
          return true;
      }
      if (size / 1024 / 1024 > 10) {
        this.toastr.error("Image size must be less than 10 MB");
        (<HTMLInputElement>document.getElementById('uploadUserImage')).value = "";
        return true;
      }
      reader.onload = function (e) {
        file = e.target;
        (<HTMLInputElement>document.getElementById('userProfilePreview')).setAttribute("src", file.result);
      }
      reader.readAsDataURL(event.target.files[0]);
      this.ProfilePhoto = event.target.files[0];
    } else {
      (<HTMLInputElement>document.getElementById('userProfilePreview')).setAttribute("src", "assets/img/default_img.jpg");
      this.ProfilePhoto = null;
      (<HTMLInputElement>document.getElementById('uploadUserImage')).value = '';
      this.profileForm.controls['Photo'].setValue('');
      this.profileForm.patchValue({
        Photo: '',
      });
    }
  }
}
